import { WizardStepRenderParams } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { BankAccountMembershipSelector } from 'modules/banking/components/BankAccountMembershipSelector'
import { WizardData } from 'modules/banking/components/FinishSetupAccountModal/types'
import { WizardStepLayoutF0 } from 'modules/banking/components/FinishSetupAccountModal/wizardSteps/WizardStepLayoutF0'
import { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'

export const FinishSetupMembershipsWizardStepF0 = ({
  data,
  onDataChanged,
}: WizardStepRenderParams<WizardData>) => {
  const handleSelectEmployees = (selection: EmployeeSelectorV2MultiSelectState) => {
    onDataChanged({ ...data, employeeSelection: selection })
  }

  return (
    <WizardStepLayoutF0
      title={i18n.t('banking.accounts.finish_wizard.step_3.title')}
      subtitle={i18n.t('banking.accounts.finish_wizard.step_3.subtitle')}
    >
      <BankAccountMembershipSelector onChange={handleSelectEmployees} />
    </WizardStepLayoutF0>
  )
}
